// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3uQME","actions":"GroupTable_actions__2l-R3","deleteModalFooter":"GroupTable_deleteModalFooter__1nuXe"};